
import React from "react";
import { Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import animationData from "../../../lottie/successfully_send_lottie/Successfully_Send_Lottie.json"
import "./Send_Msg_Modal.css";

const Send_Msg_Modal = ({ showRequestSent, handleRequestSendClose }) => {
  return (
    <Modal 
      show={showRequestSent} 
      onHide={handleRequestSendClose} 
      centered 
      className="msg-send-modal"
    >
      <Modal.Body className=" modal-request">
        <div className="modal-card-container text-center">
          <div className="request-circle-icon">
            <Lottie
              animationData={animationData} 
              loop={true}
            />
          </div>
          <div className="request-content">
            <h5 className="request-text">Message Send Successfully</h5>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Send_Msg_Modal;